<template>
  <div class="footer-button-container">
    <button class="popup-footer-button secondary-button left" @click="handleFooterButtonClick()">
      <i class="fa-regular fa-chevron-left"></i>
      {{ $t('export.label.back') }}
    </button>
    <p class="popup-footer-error">{{ errorMessage }}</p>
    <button class="popup-footer-button primary-button" @click.prevent="downloadExportFile" >
      {{ $t('other.download') }}
      <i class="fa-regular fa-cloud-arrow-down"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ShareCompleteFooter',
  props: {
    exportProjects: {
      type: Array,
      required: true
    },
    errorMessage: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    handleFooterButtonClick() {
      this.$emit('setNextPage', { nextComponent: 'ShareExport', nextFooter: 'ShareExportFooter' })
      this.$emit('goNextPage')
    },
    downloadExportFile() {
      this.$store.dispatch('downloadExportFiles', this.exportProjects)
    }
  }
}
</script>
